import {lazy} from 'react';

const UserManagementList = lazy(() => import('./UserManagementList'));

export default UserManagementList;
